import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-invite-member-public',
  standalone: false,
  templateUrl: './invite-member-public.component.html',
  styleUrls: ['./invite-member-public.component.scss'],
})
export class InviteMemberPublicComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    const uniqueKey = this.route.snapshot.paramMap.get('id');
    console.log('From route param:', uniqueKey);

    if (uniqueKey) {
      const expiryDate = new Date();
      expiryDate.setMinutes(expiryDate.getMinutes() + 30);

      this.cookieService.set('uniqueKey', uniqueKey, {
        expires: expiryDate,
        path: '/',
      });

      setTimeout(() => {
        this.router.navigate(['/dashboard']);
      }, 100);
    }
  }
}
